import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=1dc89c1b&scoped=true&"
import script from "./alarm.vue?vue&type=script&lang=js&"
export * from "./alarm.vue?vue&type=script&lang=js&"
import style0 from "./alarm.vue?vue&type=style&index=0&id=1dc89c1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc89c1b",
  null
  
)

export default component.exports